export const ADD_FILE = 'ADD_FILE';
export const UPDATE_FILE = 'UPDATE_FILE';
export const DELETE_FILE = 'DELETE_FILE';
export const CLEAR_FILES = 'CLEAR_FILES';

export const addFile = file => ({
    type: ADD_FILE,
    payload: file,
})

export const updateFile = file => ({
    type: UPDATE_FILE,
    payload: file,
})

export const deleteFile = file => ({
    type: DELETE_FILE,
    payload: file,
})

export const clearFiles = () => ({
    type: CLEAR_FILES,
})